// extracted by mini-css-extract-plugin
module.exports = {"TimelineDot":"Education_TimelineDot__2GAS0","Year":"Education_Year__NbqQm","Title":"Education_Title__31AWY","University":"Education_University__3fQg4"};